import { ArrowsInIcon, ArrowsOutIcon } from '@phosphor-icons/react';
import { FC } from 'react';

import { VariantType } from '@enums';
import type { ZoomButtonProps } from '@types';
import { cn } from '@utils';

import { Button } from '.';

export const ZoomButton: FC<ZoomButtonProps> = ({ isFullScreen = false, toggleFullScreen }) => {
  const ZoomIcon = isFullScreen ? ArrowsInIcon : ArrowsOutIcon;

  return (
    <Button
      className={cn(
        'p-3 size-12 rounded-full enabled:shadow-none',
        isFullScreen && 'bg-black bg-opacity-5 text-blue-400',
      )}
      hoverEffect
      variant={VariantType.Clean}
      onClick={toggleFullScreen}
      adornment={<ZoomIcon className={cn('size-5 sm:size-6', !isFullScreen && 'text-gray-600')} />}
    />
  );
};
